import { Empty } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HEADERMENU_PATH } from '../../../../routes/RoutesURL';
import { commaSeperator } from '../../../utils/validation';
//import { getInterestRate } from '../utils';
import moment from 'moment';
import { InvestmentStatus, Investments } from '../redux/types';

type Props = {
    investments: Investments[];
};

const InvestmentMobileCard: React.FC<Props> = ({ investments }) => {
    const navigate = useNavigate();

    return (
        <div className="w-full flex-col">
            {investments.length === 0 && (
                <Empty description={`No Investment Data`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
            {investments.map((item, index) => (
                <div
                    className="px-4 py-2 mb-4"
                    style={{ backgroundColor: '#F5F6FF' }}
                    key={`${item.dealUUID}_${item.uuid}_${index}`}
                    onClick={() => navigate(`${HEADERMENU_PATH.investments}/${item.uuid}`)}
                >
                    <p className="font-bold text-sm p-1">{item.issuerName}</p>
                    <div className="flex flex-wrap">
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Deal</p>
                            <p className="text-xs font-normal text-color-404040">{item.dealName}</p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Instrument Type</p>
                            <p className="text-xs font-normal text-color-404040">{item.instrumentType}</p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Deal Type</p>
                            <p className="text-xs font-normal text-color-404040">{item.dealType}</p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Investment Amount</p>
                            <p className="text-xs font-normal text-color-404040">
                                {item.investmentAmount
                                    ? `${item.investmentAmount.currency} ${commaSeperator(
                                          parseFloat(String(item.investmentAmount.amountUpto2dp || 0)).toFixed(2),
                                      )}`
                                    : 'NA'}
                            </p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Investment Date</p>
                            <p className="text-xs font-normal text-color-404040">
                                {item.investmentDate ? moment(item.investmentDate).format('DD-MMM-YY') : 'NA'}
                            </p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Maturity Date</p>
                            <p className="text-xs font-normal text-color-404040">
                                {item.maturityDate ? moment(item.maturityDate).format('DD-MMM-YY') : 'NA'}
                            </p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Outstanding Principal</p>
                            <p className="text-xs font-normal text-color-404040">
                                {item.outstandingPrincipal?.amountUpto2dp
                                    ? `${item.outstandingPrincipal.currency} ${commaSeperator(
                                          parseFloat(String(item.outstandingPrincipal.amountUpto2dp || 0)).toFixed(2),
                                      )}`
                                    : 'NA'}
                            </p>
                        </div>

                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Interest Rate (p.a.)</p>
                            <p className="text-xs font-normal text-color-404040">
                                {/* {getInterestRate(item.investmentAmount.currency, item)} */}
                                {item.interestRate ? `${item.interestRate}` : 'NA'}
                            </p>
                        </div>

                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F] text_wrap">
                                Total Distribution/Interest Paid To Date
                            </p>
                            <p className="text-xs font-normal text-color-404040">
                                {/* {getInterestRate(item.investmentAmount.currency, item)} */}
                                {item.totalDistribution?.amountUpto2dp
                                    ? `${item.totalDistribution.currency} ${commaSeperator(
                                          parseFloat(String(item.totalDistribution.amountUpto2dp || 0)).toFixed(2),
                                      )}`
                                    : 'NA'}
                            </p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs text-[#182D4F]">Status</p>
                            <p
                                className={`text-xs font-normal ${
                                    item.status === InvestmentStatus.redeemed || item.status === InvestmentStatus.repaid
                                        ? 'text-[#219653]'
                                        : 'text-[#404040]'
                                }`}
                            >
                                {item.status}
                            </p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default InvestmentMobileCard;
